export const shortlistQueryKeys = {
  all: ['shortlist'] as const,
  publicJob: (code: string) =>
    [...shortlistQueryKeys.all, 'public-job', code] as const,
  publicJobCandidates: (code: string) =>
    [...shortlistQueryKeys.all, 'public-job-candidates', code] as const,
  publicJobCandidateDetail: (candidateJobId: string, code: string) =>
    [
      ...shortlistQueryKeys.all,
      'public-job-candidate-detail',
      candidateJobId,
      code,
    ] as const,
};
